import React from 'react';
import Divider from '@mui/joy/Divider';

export default function Separator() {
    return (
        <Divider
            inset="context"
            sx={{
                backgroundColor: '#b3b3b3',
                width: '100%',
                height: '1px'
            }}
        />
    );
}
